import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next"; // https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import scriptTableSchema from "./scriptTableSchema";

const RECORDS_PER_PAGE = "mbEonsRecordsPerPage";

export default class Avaliabletemplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      recordsPerPage: localStorage.getItem(RECORDS_PER_PAGE) || 50,
    };
    this.getHeader = this.getHeader.bind(this);
    this.getFilteredData = this.getFilteredData.bind(this);
    this.getKeys = this.getKeys.bind(this);
  }

  getKeys() {
    let key = this.props.data[0];
    if (!this.props.data[0]) {
      key = this.props.data[1];
    }
    return Object.keys(key);
  }

  getHeader() {
    let keys = this.getKeys();
    return keys.map((key) => {
      return <th key={`header_${key}`}>{key.toUpperCase()} </th>;
    });
  }

  getFilteredData() {
    //filter1 = type, filter2 = subtype, filter3 = companycode
    let { filter1, filter2, filter3 } = this.props;

    let { data } = this.state;
    let items = data;
    if (filter1) {
      filter1 = new Set(filter1);
      items = items.filter((d) => filter1.has(d.type.toLowerCase()));
    }

    if (filter2) {
      filter2 = new Set(filter2);
      items = items.filter((d) => filter2.has(d.subtype.toLowerCase()));
    }

    if (filter3) {
      items = items.filter((d) => d.companyCode.toLowerCase() === filter3.toLowerCase());
    }

    return items;
  }

  render() {
    return (
      <div>
        <BootstrapTable
          bootstrap4
          hover
          classes="table-responsive-md"
          keyField="companycode_vch"
          data={this.getFilteredData()}
          columns={scriptTableSchema()}
          bordered={false}
        />
      </div>
    );
  }
}
